import React__default from 'react';
import styled from 'styled-components';
import sx from '../../sx.js';

/**
 * The VisuallyHidden component supports text that is visually hidden from the UI, but is read by screen readers.
 *
 * Use with icons, buttons without text, labels, and other parts of the UI that need to provide instructions that isn't
 * immediately clear to people using screen readers or assistive technologies.
 */
const VisuallyHidden = ({
  children,
  ...rest
}) => {
  const [forceShow, setForceShow] = React__default.useState(false);
  React__default.useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      // the reveal when debugging trick doesn't really work in iFrames
      const handleKeyDown = ev => {
        if (ev.key === 'Alt') {
          setForceShow(true);
        }
      };
      const handleKeyUp = () => {
        setForceShow(false);
      };
      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('keyup', handleKeyUp);
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener('keydown', handleKeyUp);
      };
    }
  }, []);
  if (forceShow) {
    return /*#__PURE__*/React__default.createElement(Wrapper, rest, children);
  }
  return /*#__PURE__*/React__default.createElement(Wrapper, rest, children);
};
VisuallyHidden.displayName = "VisuallyHidden";
var VisuallyHidden$1 = VisuallyHidden;
const Wrapper = styled.span.withConfig({
  displayName: "VisuallyHidden__Wrapper",
  componentId: "sc-12gl7up-0"
})(["", ""], ({
  isVisible = false
}) => {
  if (isVisible) {
    return sx;
  }
  return `position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  `;
});

export { VisuallyHidden$1 as default };
